// filters.js
import CustomMultiSelect from "./custom-multi-select";

document.addEventListener("DOMContentLoaded", () => {
  const filters = [
    { id: "job-filter--domains", name: "domains" },
    { id: "job-filter--locations", name: "locations" },
  ];

  const filtersBar =
    document.querySelector(".c-job-overview__filters") ||
    document.querySelector(".c-job-alert__filters");

  if (!filtersBar) {
    return;
  }

  const containers = filters
    .map((f) => document.getElementById(f.id))
    .filter(Boolean);

  filters.forEach(({ id, name }) => {
    const el = document.getElementById(id);
    if (el) {
      new CustomMultiSelect(el, name);
    }
  });

  function updateFiltersBar() {
    filtersBar.innerHTML = "";
    containers.forEach((container) => {
      container
        .querySelectorAll('input[type="checkbox"]')
        .forEach((cb) => {
          if (cb.checked) {
            const pill = document.createElement("span");
            pill.setAttribute("data-selector", "filter");
            pill.setAttribute("data-filter", encodeURIComponent(cb.value));
            pill.textContent = cb.value;
            filtersBar.appendChild(pill);
          }
        });
    });
  }

  containers.forEach((container) => {
    container.addEventListener("change", (e) => {
      if (e.target.matches('input[type="checkbox"]')) {
        updateFiltersBar();
      }
    });
  });

  filtersBar.addEventListener("click", (e) => {
    const pill = e.target.closest('span[data-selector="filter"]');
    if (!pill) return;
    const value = decodeURIComponent(pill.getAttribute("data-filter"));
    containers.forEach((container) => {
      const cb = container.querySelector(`input[value="${value}"]`);
      if (cb) cb.checked = false;
    });
    updateFiltersBar();
  });

  updateFiltersBar();
});